module.exports = __webpack_public_path__ + "img/KNUST.089dd8e0.jpg";